jQuery(document).ready(function ($) {
    $('.js-testimonials').each(function () {
        const hasMultiple = $(this).find('.swiper-slide').length > 1;

        new Swiper(`#${$(this).attr('id')}`, {
            loop: hasMultiple,

            slidesPerView: 1,

            longSwipes: false,

            spaceBetween: 40,

            pagination: {
                el: $(this).find('.testimonials__pagination')[0],
                type: 'bullets',
                bulletClass: 'pagination__bullet',
                bulletActiveClass: 'active',
                clickable: true
            },

            autoplay: hasMultiple ? {
                delay: 8000
            } : false
        });
    });
});
